import { render } from "./Stone.vue?vue&type=template&id=4579c321"
import script from "./Stone.vue?vue&type=script&lang=js"
export * from "./Stone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Stone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4579c321"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4579c321', __exports__)) {
    api.reload('4579c321', __exports__)
  }
  
  module.hot.accept("./Stone.vue?vue&type=template&id=4579c321", () => {
    api.rerender('4579c321', render)
  })

}


export default __exports__